import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const TermsConditions = () => {
  return (
    <Container className="py-5 px-3 px-md-5">
      <Row>
        <Col>
          <Card className="p-4">
            <h1 className="mb-4">Terms and Conditions</h1>
            <p>
              These Terms and Conditions govern the use of Happilee Digital Innovations' hotel booking services. By
              accessing or using our website, you agree to these terms.
            </p>

            <h2 className="mt-4">Booking Policies</h2>
            <ul>
              <li>Reservations are confirmed upon receipt of full payment.</li>
              <li>Bookings are subject to availability, and we reserve the right to decline a booking for any reason.</li>
              <li>Customers must provide accurate contact details when booking.</li>
            </ul>

            <h2 className="mt-4">Cancellation and Modifications</h2>
            <ul>
              <li>Cancellations and changes must be requested at least 24 hours before the check-in date.</li>
              <li>Fees may apply for changes or modifications, depending on availability.</li>
            </ul>

            <h2 className="mt-4">Check-In and Check-Out</h2>
            <ul>
              <li>Standard check-in and check-out times are specified in the booking confirmation.</li>
              <li>Early check-in or late check-out requests are subject to availability and additional charges.</li>
            </ul>

            <h2 className="mt-4">User Responsibilities</h2>
            <ul>
              <li>Guests are responsible for any damage caused during their stay.</li>
              <li>Compliance with hotel policies and local regulations is mandatory.</li>
            </ul>

            <h2 className="mt-4">Limitation of Liability</h2>
            <p>
              We are not responsible for service disruptions caused by external factors such as travel delays or
              third-party services.
            </p>

            <h2 className="mt-4">Amendments</h2>
            <p>We may update these terms at any time, with changes effective upon posting.</p>

            <h2 className="mt-4">Cancellation and Refund Policy</h2>
            <h3 className="mt-3">Cancellation Requests</h3>
            <ul>
              <li>Cancellations made at least 24 hours before the check-in date will receive a full refund.</li>
              <li>Cancellations made within 24 hours of the check-in date are non-refundable.</li>
              <li>No-shows will be charged the full booking amount.</li>
            </ul>

            <h3 className="mt-3">Refund Process</h3>
            <ul>
              <li>Refunds will be processed within 7-10 business days to the original payment method.</li>
              <li>If the booking was made through a third-party platform, refunds must be requested directly from that platform.</li>
            </ul>

            <h3 className="mt-3">Booking Modifications</h3>
            <p>Modifications are subject to availability and may incur additional charges.</p>

            <h2 className="mt-4">Shipping and Delivery Policy</h2>
            <p>
              As our services are digital and related to hotel accommodations, the following policies apply:
            </p>
            
            <h3 className="mt-3">Booking Confirmation</h3>
            <p>
              Upon successful payment, a confirmation email with booking details will be sent to the provided email address.
            </p>
            <p>Customers are responsible for ensuring their contact details are accurate.</p>

            <h3 className="mt-3">Non-Delivery of Confirmation</h3>
            <p>
              If you do not receive a confirmation email, please check your spam/junk folder. If it is not found, contact us
              immediately at <a href="mailto:happileedigitalinnovations@gmail.com">happileedigitalinnovations@gmail.com</a>.
            </p>

            <h3 className="mt-3">Booking Changes</h3>
            <p>Any booking modifications must be confirmed by email or phone.</p>
          </Card>
        </Col>
      </Row>
      <div className="text-center mt-4">
        <Link to="/login" className="btn btn-primary w-100 w-md-auto">
          Back to Login
        </Link>
      </div>
    </Container>
  );
};

export default TermsConditions;